import React from 'react'

function Receiver() {
  return (
    <div>Receiver</div>
  )
}

export default Receiver